import {Controller} from "@hotwired/stimulus";
import {Collapse} from "bootstrap";

export default class extends Controller {
  // Hide for pickup is used to hide a section that should only be shown when 'pickup' is selected.
  // 'hideUnlessShipping' and 'hideUnlessPickup' are explicitly only shown when the respective radio is selected.
  static targets = ["shipOrder", "billingMatch", "showForShipping", "showForPickup", "showForPickupOrShipping"];

  connect() {
    // Store the initial state of the checkbox.
    this.previousBillingMatchState = this.billingMatchTarget.checked;

    this.showForPickupOrShippingTargets.forEach((target) => {
      if (!Collapse.getInstance(target)) {
        new Collapse(target, {toggle: false});
      }
    });

    this.toggleShippingGroup();
  }

  shipOrderChanged() {
    this.toggleShippingGroup();
  }

  toggleShippingGroup() {
    const selectedShipOrder = this.shipOrderTargets.find(radio => radio.checked);
    if (!selectedShipOrder) return;

    const isShipping = selectedShipOrder.value === "true";
    const isPickup = selectedShipOrder.value === "false";

    this.showForPickupOrShipping(isShipping || isPickup);
    this.showForShipping(isShipping);
    this.showForPickup(isPickup);

    if (isShipping) {
      // Restore the checkbox state from before switching to pickup.
      this.billingMatchTarget.checked = this.previousBillingMatchState;
    } else {
      // Save the current state before unchecking.
      this.previousBillingMatchState = this.billingMatchTarget.checked;
      this.billingMatchTarget.checked = false;
    }

    // Dispatch an input event so that any listeners on the checkbox are triggered.
    this.billingMatchTarget.dispatchEvent(new Event("input", {bubbles: true}));
  }

  // Displayed on if the selected shipping method is
  showForShipping(isShipping) {
    this.showForShippingTargets.forEach(target => {
      if (isShipping) {
        target.classList.remove("d-none");
      } else {
        target.classList.add("d-none");
      }
    });
  }

  // Displayed on if the selected shipping method is pickup.
  showForPickup(isPickup) {
    this.showForPickupTargets.forEach(target => {
      if (isPickup) {
        target.classList.remove("d-none");
      } else {
        target.classList.add("d-none");
      }
    });
  }

  showForPickupOrShipping(isShippingOrPickup) {
    this.showForPickupOrShippingTargets.forEach(target => {
      const collapseInstance = Collapse.getInstance(target);
      if (isShippingOrPickup) {
        collapseInstance.show();
      } else {
        collapseInstance.hide();
      }
    });
  }
}
